import { render, staticRenderFns } from "./SendMessageTemplateList.vue?vue&type=template&id=76b8939d&scoped=true&lang=pug"
import script from "./SendMessageTemplateList.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateList.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTemplateList.vue?vue&type=style&index=0&id=76b8939d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b8939d",
  null
  
)

export default component.exports